<template>
    <b-row>
        <b-col cols="12" v-if="loading" id="pago_loading" class="text-center d-flex justify-content-center" style="height: 50vh;">
            <LoaderComponent />
        </b-col>
        <b-col cols="12" v-else-if="procesar_pago">
            <section class="padding-vertical-content" key="pago" id="pago">
                <div class="container">
                    <h2 class="m-0 h1 text-uppercase">{{ $t('compra.confirmacion_compra') }}</h2>
                    <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('compra.introduce_datos') }}</div>
                    <PagoPaycometComponent
                        ref="pago"
                        tipo_venta="cambio-nombre"
                        :jet_id="datosCompra?.jet_id"
                        :session_id="datosCompra?.session_id"
                    />
                </div>
            </section>
        </b-col>
    </b-row>
</template>

<script>
    import PagoPaycometComponent from '@/components/frontend/compra/components/PagoPaycometComponent';

    export default {
        props: {
            datosCompra: {
                type: Object,
                required: true
            },
            loading: {
                type: Boolean,
                default: false
            },
            procesar_pago: {
                type: Boolean,
                default: false
            }
        },
        components: {
            PagoPaycometComponent
        }
    }
</script>